module.exports = __webpack_public_path__ + "static/media/Videobackground.88c43cfb.mp4";